<template>
    <!-- Main sidebar -->
    <div
        class="sidebar sidebar-main sidebar-dark sidebar-custom-bg sidebar-expand-md"
        :class="{ 'sidebar-mobile-expanded': mobile_expanded, 'sidebar-main-resized': desktop_compact, 'sidebar-main-unfold': unfolded }"
        @mouseenter="unfolded = true"
        @mouseleave="unfolded = false"
    >
        <limitless-page-sidebar-content></limitless-page-sidebar-content>

        <div class="sidebar-footer">
            <slot name="footer"></slot>
        </div>
    </div>
    <!-- /main sidebar -->
</template>

<script>
import eventBus from '@services/EventBus.js';
import LimitlessPageSidebarContent from './LimitlessPageSidebarContent.vue';

export default {
    name: 'LimitlessSidebar',
    components: {
        LimitlessPageSidebarContent,
    },
    data: () => ({
        desktop_compact: false,
        mobile_expanded: false,
        unfolded: false,
    }),
    created() {
        eventBus.$on('toggle:sidebar-main', () => {
            this.desktop_compact = !this.desktop_compact;
        });
        eventBus.$on('toggle:sidebar-mobile', () => {
            this.mobile_expanded = !this.mobile_expanded;
        });
    },
    beforeDestroy() {
        eventBus.$off('toggle:sidebar-main');
        eventBus.$off('toggle:sidebar-mobile');
    },
};
</script>
